import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import vaultsourceService from '../services/vaultsourceService';
import './VaultSourceList.css';

const VaultSourceList = () => {
  const [vaultsources, setVaultSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    loadVaultSources();
  }, []);

  const loadVaultSources = async () => {
    try {
      setLoading(true);
      setError(null);

      const filterParams = {};
      if (searchTerm) filterParams.name = searchTerm;

      const response = await vaultsourceService.getAllVaultSources(filterParams);
      setVaultSources(response.vaultsources || []);
    } catch (err) {
      console.error('Error loading vault sources:', err);
      setError(err.response?.data?.message || err.message || 'Failed to load vault sources');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this vault system?')) {
      return;
    }

    try {
      await vaultsourceService.deleteVaultSource(id);
      setVaultSources(vaultsources.filter(vs => vs.id !== id));
    } catch (err) {
      console.error('Error deleting vault system:', err);
      alert(err.response?.data?.message || 'Failed to delete vault system');
    }
  };

  const handleSearch = () => {
    loadVaultSources();
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  if (loading) {
    return <div className="loading">Loading vault systems...</div>;
  }

  return (
    <div className="vaultsource-list-container">
      <div className="header">
        <h1>Vault Systems</h1>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/admin/vaults/new')}
          title="Create New Vault System"
        >
          ➕ Add Vault System
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleSearchKeyPress}
        />
        <button className="btn btn-search" onClick={handleSearch}>
          Search
        </button>
        <button className="btn btn-secondary" onClick={() => { setSearchTerm(''); loadVaultSources(); }}>
          Clear
        </button>
      </div>

      <div className="table-container">
        <table className="vaultsource-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vaultsources.length === 0 ? (
              <tr>
                <td colSpan="2" className="no-data">No vault systems found</td>
              </tr>
            ) : (
              vaultsources.map((vaultsource) => (
                <tr
                  key={vaultsource.id}
                  onClick={() => navigate(`/admin/vaults/${vaultsource.id}`)}
                  className="clickable-row"
                  title="Click to view"
                >
                  <td>{vaultsource.name}</td>
                  <td className="actions">
                    <button
                      className="btn btn-edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/admin/vaults/${vaultsource.id}/edit`);
                      }}
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn btn-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(vaultsource.id);
                      }}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VaultSourceList;
